import { Stack, Typography } from '@mui/material';
import { ColorModeToggle } from '../../components/ColorModeToggle';
import { Panel } from '../../components/Panel';

/** Light, dark, or follow the device. The choice is remembered on this device. The same switch is in the top bar. */
export function AppearancePanel() {
  return (
    <Panel
      title="Appearance"
      subtitle="Dark mode. The choice is remembered on this device (your Mac and your iPhone each keep their own)."
    >
      <Stack direction="row" spacing={2} sx={{ alignItems: 'center', flexWrap: 'wrap', rowGap: 1 }}>
        <ColorModeToggle showLabels />
        <Typography variant="body2" color="text.secondary">
          Device follows your Mac or iPhone setting.
        </Typography>
      </Stack>
    </Panel>
  );
}
